export enum VerfahrenMessages {
	ASK_TO_REJECT_VERFAHREN = 'Soll das Verfahren abgelehnt werden?',
	ASK_TO_DELETE_VERFAHREN = 'Wollen Sie dieses Verfahren wirklich löschen?',
	ASK_TO_UNASSIGN_KONTAKT = 'Wollen Sie den letzten Kontakt wirklich aus diesem Verfahren löschen? Der Kontakt bleibt für andere Verfahren verfügbar.',
	ACKNOWLEDGE_VERFAHREN_CREATED = 'Der Vorgang wurde erfolgreich angelegt.',
	CONFIRM_ASSIGN_USIGNAL = 'Wollen Sie dem Verfahren {aktenzeichen} ein freies U-Signal zuordnen?',
}

export enum VerfahrenStatusLabel {
	VORLAEUFIG = 'Vorläufig',
	EINGETRAGEN = 'Eingetragen',
	GELOESCHT = 'Gelöscht',
	GESCHLOSSEN = 'Geschlossen',
	ABGELEHNT = 'Abgelehnt',
}

export enum ZaehlblattAktionTypLabel {
	EIGENTUEMER = 'LR - Eigentümer',
	LFZ_NEU = 'LR - LFZ Neu',
	LOESCHUNG_PFANDRECHT = 'LR - Löschung Pfandrecht',
	PFANDRECHT_NEU = 'LR - Pfandrecht neu',
	PFANDRECHTE_AN_BESTEHENDEN_LFZ = 'LR - Pfandrechte an bestehenden LFZ',
	SCHLIESSUNG_DES_BLATTES = 'LR - Schließung des Blattes',
	EINGEREICHTE_URKUNDE_ZUM_REGISTER = 'LR - eingereichte Urkunden zum Register',
	SONSTIGE = 'LR - sonstige Handlungen und Entscheidungen außerhalb eines anhängigen Verfahrens',
	EINGEREICHTE_URKUNDEN_SSR = 'SSR - eingereichte Urkunden',
	EINGEREICHTE_URKUNDEN_BSR = 'BSR - eingereichte Urkunden',
	EINGEREICHTE_URKUNDEN_SBR = 'SBR - eingereichte Urkunden',
	EINGEREICHTE_URKUNDEN_AR = 'AR - eingereichte Urkunden',
	ANLEGUNG_ETL_UND_PFANDRECHTSVOLLSTRECKUNG = 'ETL - Anlegung Ersatzteillager und Pfandrechtsvollstreckung',
	VERAENDERUNGEN_AM_ETL = 'ETL - Veränderungen am Ersatzteillager',
	VERAENDERUNGEN_AM_PFANDRECHT_ETL = 'ETL - Veränderungen am Pfandrecht',
	SCHLIESSUNG_ETL = 'ETL - Schließung Ersatzteillager',
	EINGEREICHTE_URKUNDEN_ZUM_REGISTER_ETL = 'ETL - eingereichte Urkunden zum Register',
}

export enum ZaehlblattAktionTypShortLabel {
	EIGENTUEMER = 'LR - Eigentümer',
	LFZ_NEU = 'LR - LFZ Neu',
	LOESCHUNG_PFANDRECHT = 'LR - Löschung Pfandrecht',
	PFANDRECHT_NEU = 'LR - Pfandrecht neu',
	PFANDRECHTE_AN_BESTEHENDEN_LFZ = 'LR - Pfandrechte an bestehenden LFZ',
	SCHLIESSUNG_DES_BLATTES = 'LR - Schließung des Blattes',
	EINGEREICHTE_URKUNDE_ZUM_REGISTER = 'LR - eingereichte Urkunden zum Register',
	SONSTIGE = 'LR - sonstige außerhalb Verfahren',
	EINGEREICHTE_URKUNDEN_SSR = 'SSR - eingereichte Urkunden',
	EINGEREICHTE_URKUNDEN_BSR = 'BSR - eingereichte Urkunden',
	EINGEREICHTE_URKUNDEN_SBR = 'SBR - eingereichte Urkunden',
	EINGEREICHTE_URKUNDEN_AR = 'AR - eingereichte Urkunden',
	ANLEGUNG_ETL_UND_PFANDRECHTSVOLLSTRECKUNG = 'ETL - Anlegung ETL und Pfandrechtsvollstreckung',
	VERAENDERUNGEN_AM_ETL = 'ETL - Veränderungen am ETL',
	VERAENDERUNGEN_AM_PFANDRECHT_ETL = 'ETL - Veränderungen am Pfandrecht',
	SCHLIESSUNG_ETL = 'ETL - Schließung ETL',
	EINGEREICHTE_URKUNDEN_ZUM_REGISTER_ETL = 'ETL - eingereichte Urkunden zum Register',
}

export enum VerfahrenSearchModeCommonLabel {
	'common.unsigned_aufschrift' = 'Aufschrift (unsigniert)',
	'common.unsigned_eigentuemer_namen' = 'Eigentümer (unsigniert)',

	'common.aktenzeichen' = 'Aktenzeichen',
	'common.short_aktenzeichen' = 'Aktenzeichen (ohne Abt.-Nr.)',
	'common.aufschrift' = 'Aufschrift',
	'common.blattnummer' = 'Blattnummer',
	'common.eigentuemer_namen' = 'Eigentümer',
	'common.assigned_kontakte' = 'Verfahrenskontakte',
	'common.register' = 'Register',
}

export enum VerfahrenSearchModeSchirLabel {
	'schiff.unsigned_gattung' = 'Gattung (unsigniert)',
	'schiff.unsigned_hauptbaustoff' = 'Hauptbaustoff (unsigniert)',
	'schiff.unsigned_imo_nummer' = 'IMO-Nrn. (unsigniert)',
	'schiff.unsigned_schiff_name' = 'Schiffsnamen (unsigniert)',
	'schiff.unsigned_unterscheidungssignal' = 'U-Signale (unsigniert)',

	'schiff.gattung' = 'Gattung',
	'schiff.hauptbaustoff' = 'Hauptbaustoff',
	'schiff.imo_nummer' = 'IMO-Nrn.',
	'schiff.schiff_name' = 'Schiffsnamen',
	'schiff.unterscheidungssignal' = 'U-Signale',

	'schiff.historische_schiff_namen' = 'Historische Schiffsnamen',
}

export enum VerfahrenSearchModeLfprLabel {
	'lfpr.unsigned_eintragungszeichen' = 'Eintragungszeichen (unsigniert)',
	'lfpr.unsigned_blattnummer' = 'Blattnummer der Luftfahrzeugrolle (unsigniert)',
	'lfpr.unsigned_muster' = 'Muster (unsigniert)',
	'lfpr.unsigned_werknummer' = 'Werknummer (unsigniert)',

	'lfpr.eintragungszeichen' = 'Eintragungszeichen',
	'lfpr.glaeubiger' = 'Gläubiger',
	'lfpr.blattnummer' = 'Blattnummer der Luftfahrzeugrolle',
	'lfpr.muster' = 'Muster',
	'lfpr.werknummer' = 'Werknummer',
	'lfpr.standort_akte' = 'Standort der Akte',
	'lfpr.ar_kennzeichen' = 'Kennzeichen (AR)',

	'lfpr.historisches_eintragungszeichen' = 'Historisches Eintragungszeichen',
	'lfpr.historische_blattnummer_rolle' = 'Historische Blattnummer der Luftfahrzeugrolle',
}

export const VerfahrenSearchModeLabel = {
	...VerfahrenSearchModeCommonLabel,
	...VerfahrenSearchModeSchirLabel,
	...VerfahrenSearchModeLfprLabel,
};

export type VerfahrenSearchKey = string;
export type VerfahrenSearchModeLabel = typeof VerfahrenSearchModeLabel;
